import type { WizardState } from './types';

/**
 * The wizard's initial state.
 *
 * Deliberately not persisted to localStorage: the form carries an owner's
 * identity documents and parcel location, and leaving that in a shared browser
 * after the tab closes is a liability, not a convenience. Progress survives
 * back/forward between steps because it lives at the App level.
 */
export function createInitialState(): WizardState {
  return {
    selection: {
      method: 'draw',
      geojson: null,
      areaSqm: null,
      centroid: null,
      localityGuess: '',
    },
    details: {
      areaSqm: '',
      judet: '',
      localitate: '',
      cut: '',
      pot: '',
      statutTeren: '',
      zonare: '',
      zonareAlt: '',
      stareTeren: '',
      situatieJuridica: '',
      utilitati: [],
      drum: '',
      intentieNote: '',
    },
    contact: {
      name: '',
      email: '',
      phone: '',
      consent: false,
    },
    files: {
      certificate: null,
      additional: [],
    },
  };
}
